import { Row, Col, Image, Container, Button, Modal, Form } from "react-bootstrap";
import "./DoctorProfile.css";
import { GoHorizontalRule } from "react-icons/go";
import { motion } from "framer-motion";
import { useState } from "react";

function DoctorProfile() {

  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    treatment: "",
    date: ""
  });

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const scriptURL = "https://script.google.com/macros/s/AKfycbxQzpZpKCzBeBuAju8jsOCXFuThomZFdh8-Yx_IELE1omgw23KXNteOrt7qVSubU3hmqw/exec";

    try {
      await fetch(scriptURL, {
        method: "POST",
        body: JSON.stringify(formData)
      });

      alert("Appointment Booked Successfully!");

      setShowModal(false);

      setFormData({
        name: "",
        phone: "",
        treatment: "",
        date: ""
      });

    } catch (error) {
      alert("Error submitting form");
    }
  };

  return (
    <section className="doctor-container d-flex">
      <Container fluid>
        <Row className="align-items-center text-center text-md-start py-5">

          {/* Left Image */}
          <Col md={7} className="left-img d-flex justify-content-center px-5">
            <Image
              src="drTrupti.jpeg"
              alt="Doctor Profile"
              className="doctor-img"
              fluid
            />

            <div className="degree-box">
              <h6 className="mb-0">Dr. Trupti Hambire</h6>
              <small>BAMS, PGDCC, Cosmetologist AND Ayurvedacharya</small>
            </div>
          </Col>

          {/* Right Text */}
          <Col md={5} className="right-text overflow-hidden">

            <motion.div
              initial={{ opacity: 0, x: 200 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true }}
            >

              <span className="hero-speacial text-uppercase">
                Best Cosmetologist in <strong>Pimpri Chinchwad</strong>
              </span>

              <h2 className="fw-bold name">DR. TRUPTI HAMBIRE</h2>

              <h5 className="text-muted pt-3">
                A clinical Cosmetologist and Ayurvedacharya
              </h5>

              <div className="speciality">
                <p className="sub-speciality">
                  <GoHorizontalRule /> HEALTH SPECIALIST
                </p>
                <p className="sub-speciality">
                  <GoHorizontalRule /> SKIN SPECIALIST
                </p>
                <p className="sub-speciality">
                  <GoHorizontalRule /> HAIR SPECIALIST
                </p>
              </div>

              <Button
                size="lg"
                className="appointment-btn fw-bold shadow-lg squared-pill"
                onClick={handleShow}
              >
                Book Appointment
              </Button>

            </motion.div>

          </Col>
        </Row>
      </Container>

      {/* Modal */}

      <Modal show={showModal} onHide={handleClose} centered>

        <Modal.Header closeButton>
          <Modal.Title>Book Appointment</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <Form onSubmit={handleSubmit}>

            <Form.Group className="mb-3">
              <Form.Label>Full Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="tel"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Treatment</Form.Label>
              <Form.Select
                name="treatment"
                value={formData.treatment}
                onChange={handleChange}
              >
                <option>Select Treatment</option>
                <option>Skin Treatment</option>
                <option>Hair Treatment</option>
                <option>Laser Treatment</option>
                <option>Acne Treatment</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button type="submit" variant="dark" className="w-100">
              Book Appointment
            </Button>

          </Form>

        </Modal.Body>

      </Modal>

    </section>
  );
}

export default DoctorProfile;